import { createTheme } from '@mui/material/styles'
import { colors, typography, zIndex } from './designTokens'

declare module '@mui/material/styles' {
	interface BreakpointOverrides {
		compact: true
		twoCol: true
		lgNarrow: true
		xxl: true
		mobileMd: true
	}

	interface ZIndex {
		stickyHeader: number
		checkoutStickyHeader: number
		absoluteOverlay: number
	}
}

export const theme = createTheme({
	zIndex: {
		stickyHeader: zIndex.stickyHeader,
		checkoutStickyHeader: zIndex.checkoutStickyHeader,
		absoluteOverlay: zIndex.absoluteOverlay,
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			compact: 361, // Compact mobile upper boundary — 360px and below (matches breakpoints.compact in designTokens)
			mobileMd: 480, // Medium mobile — 479px and below; tip section single-row threshold (matches breakpoints.mobileMd in designTokens)
			twoCol: 640, // Two-column card grid lower bound (Figma menu item grid spec)
			md: 721, // Figma desktop-small lower bound — 720px and below is mobile/tablet
			lg: 1025, // Figma desktop lower bound
			lgNarrow: 1133, // Upper bound of narrow desktop range (1025–1132px) where sidebar is compact
			xl: 1280,
			xxl: 1440, // Figma wide-desktop frame — padding removed, content fills edge to edge
		},
	},
	typography: {
		fontFamily: typography.fontFamily,
	},
	palette: {
		primary: {
			main: colors.brand,
		},
		text: {
			primary: colors.textPrimary,
			secondary: colors.textSecondary,
			disabled: colors.textDisabled,
		},
		divider: colors.divider,
		error: {
			main: colors.error,
		},
		background: {
			paper: colors.surfaceWhite,
			default: colors.surfaceMuted,
		},
	},
})
